const firebaseConfig = {
  apiKey: "AIzaSyDLz5UOV2BcURBvob_893iN8KVoj1V-hgs",
  authDomain: "medicare-hospital-4e5f3.firebaseapp.com",
  projectId: "medicare-hospital-4e5f3",
  storageBucket: "medicare-hospital-4e5f3.appspot.com",
  messagingSenderId: "308530853736",
  appId: "1:308530853736:web:f8cbbf28a379233a3308dd"
};
export default firebaseConfig;
